import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  boxTitle:{
    display: 'flex !important',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  boxCheckbox:{
    margin: '2rem 0 2rem 0 !important'
  },
  boxButtons:{
    display: 'flex', 
    justifyContent: 'space-between'
  },
  boxTextField:{
    display: 'flex !important', 
    gap:'2rem !important'
  },
  boxCircular:{
    width:'100%', 
    height: '20rem', 
    display: 'flex',
    justifyContent:'space-evenly',
    alignItems: 'center'
  },
  titulo:{
    fontSize: '1.5rem !important',
    fontWeight: '600 !important',
    lineHeight:'1.828rem !important',
    color: '#1D1D1D'
  },
  subtitulo:{
    fontSize: '0.875rem !important',
    fontWeight: '500 !important',
    lineHeight:'1.75rem !important',
    color: '#616161'
  },
  firstDivider:{
    width: '100%',
    marginBottom: '2rem !important',
    marginTop: '2rem !important'
  },
  buttonHelp:{
    border: '1px solid #B0B0B0 !important',
    color: 'black !important',
    fontSize: '0.875rem !important',
    fontWeight: '500 !important',
    lineHeight:'1rem !important',
    padding: '0.75rem !important'
  },
  buttonConect:{
    border: '1px solid #B0B0B0 !important',
    color: 'black !important',
    fontSize: '0.875rem !important',
    fontWeight: '500 !important',
    lineHeight:'1rem !important',
    padding: '0.75rem !important'
  },
  buttonPular:{
    border: '1px solid #B0B0B0 !important',
    color: 'black !important',
    fontSize: '1rem !important',
    fontWeight: '500 !important',
    lineHeight:'1.2rem !important',
    padding: '0.75rem 1rem 0.75rem 1rem !important'
  },
  buttonContinuar:{
    background: '#2813AD !important',
    color: '#FFFFFF !important',
    fontSize: '1rem !important',
    fontWeight: '600 !important',
    lineHeight:'1.2rem !important',
    padding: '0.75rem 1rem 0.75rem 1rem !important'
  },

  labelChekBox:{
    fontSize: '0.875rem !important',
    fontWeight: '500 !important',
    lineHeight:'1.375rem !important',
    color: '#616161'
  }
}));